import { Navigate } from "react-router-dom";

const Guest = ({ children }) => {
  const routeName = children.type.displayName;

  if (localStorage.getItem("accessToken") && routeName !== "FindPassword") {
    return <Navigate to="/home" replace={true} />;
  }

  return children;
};

export default Guest;
